import { useEffect, useState } from "react";
import { BaseInfo, Guid } from "../../../../api/baseApi";
import { ChannelSystemType, getTVChannels, TVChannel } from "../../../../api/tvChannelApi";
import { getScheduledPriorityLists, ScheduledPriorityList } from "../../../../api/priorityListApi";
import { getTags } from "../../../../api/tagApi";

export const useSkyTvGuideData = () => {
    const [priorityLists, setPriorityLists] = useState<ScheduledPriorityList[]>([]);
    const [tvChannelsList, setTvChannelsList] = useState<TVChannel[]>([]);
    const [tags, setTags] = useState<BaseInfo[]>([]);

    useEffect(() => {
        (async () => {
            const plResult = await getScheduledPriorityLists();
            if (plResult.type === 'succes') setPriorityLists(plResult.data.items);

            const chResult = await getTVChannels();
            if (chResult.type === 'succes') {
                setTvChannelsList(chResult.data.items.filter(c => c.channelSystemType === ChannelSystemType.SkyTVScrapped));
            }

            const tagResult = await getTags();
            if (tagResult.type === 'succes') setTags(tagResult.data.items);
        })();
    }, []);

    return { priorityLists, tvChannelsList, tags };
};
